import React, { useState, useEffect } from 'react';
import {
  Button,
  Label,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from 'reactstrap';

/**
 * Modal to create or edit a version
 */
function VersionModal({
  title = 'Versión',
  isOpen = false,
  onToggle = () => {},
  defaultVersion = null,
  onSubmit = () => {},
}) {
  const [name, setName] = useState('');

  // Update form when defaultVersion changes (for edit mode)
  useEffect(() => {
    if (defaultVersion) {
      setName(defaultVersion.name || '');
    } else {
      setName('');
    }
  }, [defaultVersion]);

  const handleSubmit = () => {
    if (!name.trim()) return;
    onSubmit(name.trim());
    handleCancel(); // Close modal and reset form
  };

  const handleCancel = () => {
    // Reset form to original values
    if (defaultVersion) {
      setName(defaultVersion.name || '');
    } else {
      setName('');
    }
    onToggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={onToggle} size="md">
      <ModalHeader toggle={onToggle}>{title}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="versionName">Nombre de la versión</Label>
          <Input
            id="versionName"
            type="text"
            placeholder="Ingrese el nombre de la versión"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSubmit();
              }
            }}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleCancel}>
          Cancelar
        </Button>
        <Button color="primary" onClick={handleSubmit} disabled={!name.trim()}>
          {defaultVersion ? 'Actualizar' : 'Crear'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default VersionModal;
